var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fileType === 'pdf'),expression:"fileType === 'pdf'"},{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"pdf",staticStyle:{"height":"500px","overflow":"auto"},attrs:{"id":"pdf"}},[_c('pdf',{ref:"print1",staticStyle:{"width":"100%"},attrs:{"src":this.baseURL +
              'httpfile.svt/wxarticle?token=' +
              this.token +
              '&fileName=' +
              _vm.fileName+
              '&keyId='+
              _vm.uuid,"page":_vm.currentPage},on:{"num-pages":function($event){_vm.pageCount=$event},"page-loaded":function($event){_vm.currentPage=$event},"loaded":_vm.loadPdfHandler}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }